import React, { useState } from "react";
import {Outlet, Link, useLocation } from "react-router-dom";
import './Kontakt.css';
import Footer from "../components/Footer";

const Kontakt = () => {

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    return(
        <section className="container-kontakt"
        style={{ overflow: 'hidden'}}>
            <div className="navbar-kontakt"
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/kontakt-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                {/* Burger Button (mobile only) */}
                <div className="burger-button" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
    
                {/* Mobile Menu */}
                <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                    <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                    <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                    <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                    <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                    <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                    <Link to="/datenschutz" onClick={toggleMobileMenu}>Datenschutz</Link>
                    <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                </nav>
    
                {/* Hexagon Nav (desktop) */}
                <section className="hero--inner">
                    <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/datenschutz" className="link">Datenschutz</Link></i></div></div>
                    <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                </section>
            </div>
            <div className="none-navbar"
            style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/kontakt-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
            <div className="kontakt-wrapper">
                <div className="kontakt-form-container">
                    <h1 className="kontakt-heading">Kontakt</h1>
                    <p className="kontakt-subtext">
                    Du hast Fragen oder brauchst Unterstützung? Kontaktiere uns gern über das Formular unten.
                    </p>

                    <form className="kontakt-form">
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" id="name" name="name" required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">E-Mail</label>
                        <input type="email" id="email" name="email" required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="message">Nachricht</label>
                        <textarea id="message" name="message" rows="5" required />
                    </div>

                    <button type="submit" className="submit-button">Absenden</button>
                    </form>
                </div>
                <div>
                    <div className="kontakt-map-container">
                        <iframe
                        title="LAM Autoservice Standort"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2495.4653809958477!2d7.2263184769544315!3d51.28415932698682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b92870589dc981%3A0x315dfee2476699af!2sSchwarzbach%20152%2C%2042277%20Wuppertal!5e0!3m2!1sde!2sde!4v1745333427624!5m2!1sde!2sde"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>

                    </div>

                    <div className="kontakt-info">
                            <h2>Unsere Kontaktdaten</h2>
                            <p><strong>Adresse:</strong> Schwarzbach 152, 42277 Wuppertal</p>
                            <p><strong>E-Mail:</strong> <a href="mailto:info@lam-autoservice.de">info@lam-autoservice.de</a></p>
                            <p><strong>Telefon:</strong> +49 176 72987527</p>

                            <h3>Öffnungszeiten</h3>
                            <p>Mo – Fr: 08:00 – 17:00 Uhr</p>
                            <p>Sa: 09:00 – 13:00 Uhr</p>
                            <p>So & Feiertage: geschlossen</p>
                    </div>
                </div>
            </div>
            </div>
            <div className="footer-homepage">
            < Footer />
            </div>
            <Outlet />
        </section>
    );
};

export default Kontakt;

/**
 * <div class="hexagon-wrapper">
            <div class="hexagon" id="hexagon-über-uns">
                <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
            </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-leistungen">
                <div class="hexagon" >
                    <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-aktuelles">
                <div class="hexagon">
                    <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-kontakt">
                <div class="hexagon">
                    <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-impressum">
                <div class="hexagon">
                    <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-datenschutz">
                <div class="hexagon">
                    <i class="fab-datenschutz"><Link to="/datenschutz" class="link">Datenschutz</Link></i>
                </div>
            </div>
            <div class="hexagon-wrapper" id="hexagon-blog">
                <div class="hexagon">
                    <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                </div>
            </div>
 */